module.exports = __webpack_public_path__ + "static/img/bottom2.acad500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom2.png
// module id = B+XP
// module chunks = 1